import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-the-system',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './the-system.component.html',
  styleUrl: './the-system.component.scss',
})
export class TheSystemComponent {
  @Input() userLoggedIn = false;
  @Output() evaluateClick = new EventEmitter<void>();
  @Output() exploreClick = new EventEmitter<void>();

  onEvaluateClick() {
    this.evaluateClick.emit();
  }

  onExploreClick(event: Event) {
    if (!this.userLoggedIn) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.exploreClick.emit();
  }
}
